export default "__VITE_ASSET__BTm6Gxqb__"